import {withClass} from '../helpers/react-helpers'

const ContentIndent = withClass<'div'>('div','content-indent')
export default ContentIndent
